import { render, staticRenderFns } from "./BaseImage.vue?vue&type=template&id=bbb47184&scoped=true&"
import script from "./BaseImage.vue?vue&type=script&lang=js&"
export * from "./BaseImage.vue?vue&type=script&lang=js&"
import style0 from "./BaseImage.vue?vue&type=style&index=0&id=bbb47184&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb47184",
  null
  
)

export default component.exports